import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { AiGenerationRating } from 'automation-ui-enrollment/components/aiAssistant/constants/AiGenerationRating';
export const AI_GENERATED_ACTIONS_FEEDBACK = registerMutation({
  fieldName: 'aiGeneratedActionsFeedback',
  args: ['correlationId', 'rating', 'feedback'],
  fetcher: ({
    correlationId,
    rating,
    feedback
  }) => {
    const feedbackField = rating === AiGenerationRating.THUMBS_UP ? 'acceptedValues' : 'rejectedValues';
    return http.post('opshub-ai/v0/workflows-copilot/generation/actions/feedback', {
      data: [{
        correlationId,
        [feedbackField]: [feedback]
      }]
    });
  }
});